import { Drawer, message } from 'antd';
import React from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Field, getFormValues, reduxForm } from 'redux-form';
import i18n from '../../../../../../lib/i18n';
import FieldInput from '../../../../../../components/Fields/FieldInput';
import { required } from 'redux-form-validators'
import { Button } from 'reactstrap';
import TreeSelectField from '../../../../../../components/Fields/TreeSelectField';
import config from '../../../../../../config';

function FormData({ initialValues, handleSubmit, onSave = () => { }, reset }) {
  const isShowModal = useSelector(state => state.slider.isShowModal);
  const dispatch = useDispatch();
  const formValues = useSelector(state => getFormValues('slider')(state)) || {};
  let folders = useSelector(state => state.slider.folders);
  const subfolders = useSelector(state => state.slider.subfolders);
  const siteUrl = config.sliderUrl;
  const copy = () => {
    var copyText = document.getElementById("question_frame");
    const text = copyText?.value || copyText?.textContent || '';
    navigator.clipboard.writeText(text).then(() => {
      message.success(i18n('msgFrameViewCopy'));
    }).catch(() => {
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand("copy");
      message.success(i18n('msgFrameViewCopy'));
    });
  }

  const treeData = folders.map(_i => ({
    title: _i.title,
    value: _i.id,
    disabled: true,
    children: subfolders.filter(_s => _s.parent_id == _i.id).map(_s => ({
      title: _s.title,
      value: _s.id,
      children: subfolders.filter(_f => _f.parent_id == _s.id).map(_f => ({
        title: _f.title,
        value: _f.id,
      }))
    }))
  }))

  return (
    <Drawer
      title={i18n('pr_slider_form')}
      placement="right"
      width={Math.min(600, window.innerWidth)}
      onClose={() => {
        dispatch({ type: 'SET_SLIDERS_KEY', key: 'isShowModal', data: false })
        reset();
      }}
      open={isShowModal}
    >
      <form onSubmit={handleSubmit(onSave)}>
        <Field
          component={TreeSelectField}
          name="folder_id"
          label={i18n('pr_folder')}
          validate={[required({ msg: i18n('is required') })]}
          treeData={treeData}
        />
        <Field component={FieldInput} name="name" label={i18n('pr_name')} validate={[required({ msg: i18n('is required') })]} />
        <Button color="primary" style={{ width: '100%', marginTop: 20 }}>{i18n('Save')}</Button>
      </form>
    </Drawer>
  )
}
export default reduxForm({
  // reset() wipes syncErrors and the values do not change, so the default check never revalidates
  shouldError: () => true,
  form: 'slider',
  enableReinitialize: true
})(FormData)